import { PlanActionTypes } from "../models/planActions";
import { SET_PLAN_META } from "../types";

export default (data: {
    cat: "opus" | "rhythm" | "pitch" | "teaching",
    prop: string,
    val: any,
}): PlanActionTypes => ({
    type: SET_PLAN_META,
    payload: data,
});
